import React from "react";
import { useFormData } from "../../contexts/FormDataContext.js";
import { useLanguage } from "../../contexts";
import Publication from "../Publication.js";

export default function PublicationsSection({ readOnly = false }) {
  const { formData, handleChange } = useFormData();
  const { t } = useLanguage();

  const addNewPublication = () => {
    if (readOnly) return;
    const newPublication = {
      type: "",
      publicationTitle: "",
      journalConfTitle: "",
      year: "",
      issn: "",
    };
    const updatedPublications = [...formData.publications, newPublication];
    handleChange("publications", updatedPublications);
  };

  return (
    <div className="overflow-hidden"> 
      <legend className="text-sm/6 font-semibold text-gray-900 dark:text-[var(--color-text-primary)]">
        {t("sections.publications.title")}
      </legend>
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-8 pt-1 pb-0 sm:pb-2"></div>
        <div className="grid grid-cols-1 pt-2 gap-y-6">
          {formData.publications.map((publication, index) => (
            <Publication
              key={publication?.id ?? `publication-${index}`}
              index={index}
              readOnly={readOnly}
            />
          ))}
          {formData.publications.length === 0 && (
            <div className="text-center text-gray-500 dark:text-[var(--color-text-muted)] py-8">
              <p>{t("sections.publications.empty")}</p>
              {!readOnly && (
                <p className="text-sm mt-2">
                  {t("sections.publications.emptyHint")}
                </p>
              )}
            </div>
          )}
        </div>
        {!readOnly && (
          <div className="flex items-center justify-center sm:justify-start gap-x-6 pt-5 mt-3 sm:pt-0">
            <button
              onClick={addNewPublication}
              type="button"
              className="rounded-md bg-patras-buccaneer px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-patras-sanguineBrown focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              {t("sections.publications.addNew")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
